import { Stack } from '@chakra-ui/react';
import { Bleed, Card, Heading } from '@main/complykit';
import { createRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { VendorQuestionnairesTable } from '../features/vendor-questionnaires/questionnaires-table';
import { vendorLayout } from './vendorToken';

const QuestionnairesPage = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={6}>
      <Heading size="xl">{t('vendors.questionnaires.heading')}</Heading>

      <Card>
        <Bleed>
          <VendorQuestionnairesTable />
        </Bleed>
      </Card>
    </Stack>
  );
};

export const vendorQuestionnairesRoute = createRoute({
  getParentRoute: () => vendorLayout,
  path: 'questionnaires',
  component: QuestionnairesPage,
});
